<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("Template.setting") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-3>
                    <v-btn color="#077893" outlined to="/template-bot-add">
                      <v-icon class="mr-1">mdi-plus</v-icon>
                      {{ $t("Template.add") }}
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 lg4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-card outlined>
                  <v-data-table
                    class="ellipsis"
                    :headers="headers"
                    :items="ItemTemplate"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.Id`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-icon
                              v-on="on"
                              v-bind="attrs"
                              style="cursor: pointer"
                              @click="handleCopyClick(item.Id)"
                              color="#077893"
                              :key="iconState[item.Id] || 'copy'"
                              class="icon-transition"
                            >
                              {{
                                iconState[item.Id] === "copied"
                                  ? "mdi mdi-check"
                                  : "mdi mdi-content-copy"
                              }}
                            </v-icon>
                          </div>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.Title`]="{ item }">
                      <div class="text-truncate" style="max-width: 300px">{{ item.Title == "" ? "-" : item.Title }}</div>
                      <!-- <v-list-item-icon class="mr-3"> -->
                      <!-- </v-list-item-icon> -->
                    </template>
                    <template v-slot:[`item.Name`]="{ item }">
                      <div class="text-truncate" style="max-width: 300px">
                        {{ item.Name }}
                      </div>
                    </template>
                    <template v-slot:[`item.CustomNotification`]="{ item }">
                      <div class="text-truncate" style="max-width: 300px">
                        {{ item.CustomNotification }}
                      </div>
                    </template>
                    <template v-slot:[`item.Image`]="{ item }">
                      <div>
                        <v-icon @click="Fn_ShowImage(item.Image, item.Name)"
                          >mdi mdi-image-multiple
                        </v-icon>
                      </div>
                    </template>
                    <template v-slot:[`item.Details`]="{ item }">
                      <div>
                        <v-icon @click="Fn_ShowDetail(item.Details, item.Name)"
                          >mdi mdi-menu
                        </v-icon>
                        <!-- {{ item.Details == "" ? "-" : item.Details }} -->
                      </div>
                    </template>
                    <template v-slot:[`item.CreatedAt`]="{ item }">
                      <div>{{ formatDate(item.CreatedAt) }}</div>
                    </template>
                    <template v-slot:[`item.CreatedBy`]="{ item }">
                      <div>
                        {{ item.CreatedBy == "" ? "-" : item.CreatedBy }}
                      </div>
                    </template>

                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            :disabled="item.Name == 'default'"
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>
                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title primary-title>
            <v-layout row>
              <v-flex lg6>
                <span>{{ TemplateName }}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="dialog = false">ปิด</v-btn>
                </v-card-actions>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
            <v-img :src="imageShow" max-height="500" contain></v-img>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDetail" max-width="900px">
        <v-card class="rounded-lg">
        <v-card-title>
          Detail ({{ ShowName }})
        </v-card-title>
        <v-card-text elevation-0>
          <v-card class="elevation-0 pa-2">
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="ShowDetail === '' ? '-' : ShowDetail"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="dialogDetail = false">
            {{ $t("consentform.off") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <div v-if="isLoading">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import moment from "moment";
import "moment/locale/th"; // สำหรับภาษาไทย
export default {
  components: { OverlaySearch },
  data() {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      LoadingSave: false,
      dialog: false,
      dialogDetail: false,
      isLoading: false,
      imageShow: null,
      TemplateName: "",
      ShowDetail: "",
      ShowName: "",
      iconState: {},
      ItemTemplate: [
        // {
        //   no: "1",
        //   Id: "template-123",
        //   Name: "Template A",
        //   Title: "หัวข้อ A",
        //   CustomNotification: "แจ้งเตือน A",
        //   CreatedAt: "2023-10-27 10:00:00",
        //   Details: "รายละเอียด A",
        //   Image: "imageA.jpg",
        //   CreatedBy: "user1",
        // },
        // {
        //   no: "2",
        //   Id: "template-456",
        //   Name: "Template B",
        //   Title: "หัวข้อ B",
        //   CustomNotification: "แจ้งเตือน B",
        //   CreatedAt: "2023-10-26 15:30:00",
        //   Details: "รายละเอียด B",
        //   Image: "imageB.png",
        //   CreatedBy: "user2",
        // },
        // {
        //   no: "3",
        //   Id: "template-789",
        //   Name: "Template C",
        //   Title: "หัวข้อ C",
        //   CustomNotification: "แจ้งเตือน C",
        //   CreatedAt: "2023-10-25 09:45:00",
        //   Details: "รายละเอียด C",
        //   Image: "imageC.gif",
        //   CreatedBy: "user3",
        // },
      ],
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        // {
        //   icon: "mdi-trash-can",
        //   text: "ลบข้อมูล",
        //   text2: "Delete",
        //   color: "red",
        //   service: "Del",
        // },
      ],
      itemsAction2: [
        {
          icon: "mdi mdi-image-multiple",
          text: "ดูรูปภาพ",
          text2: "see",
          color: "orange",
          service: "see",
        },
        // {
        //   icon: "mdi-trash-can",
        //   text: "ลบข้อมูล",
        //   text2: "Delete",
        //   color: "red",
        //   service: "Del",
        // },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          value: "no",
          sortable: false,
          align: "center",
        },
        {
          text: "หมายเลข Template Bot",
          value: "Id",
          align: "center",
          sortable: false,
        },
        {
          text: "ชื่อ Template",
          value: "Name",
          align: "center",
          sortable: false,
        },
        {
          text: "หัวข้อ",
          align: "center",
          value: "Title",
          sortable: false,
        },
        {
          text: "แจ้งเตือน",
          align: "center",
          value: "CustomNotification",
          sortable: false,
        },
        {
          text: "รายละเอียด",
          value: "Details",
          align: "center",
          sortable: false,
        },
        {
          text: "รูปภาพ",
          value: "Image",
          align: "center",
          sortable: false,
        },
        {
          text: "ผู้สร้าง",
          value: "CreatedBy",
          align: "center",
          sortable: false,
        },
        {
          text: "วันที่สร้าง",
          value: "CreatedAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetAllTemplate();
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "-"; // หรือ return ค่าเริ่มต้นอื่นๆ ตามต้องการ
      return moment(dateString).locale("th").format("DD MMM YYYY HH:mm:ss");
    },
    handleCopyClick(id) {
      // ตั้งค่าสถานะเป็น 'copied' สำหรับไอคอนนี้
      this.Fn_CopyDetail(id);
      this.$set(this.iconState, id, "copied");

      // หลังจาก 2 วินาที เปลี่ยนกลับเป็นไอคอนเดิม
      setTimeout(() => {
        this.$set(this.iconState, id, "copy");
      }, 1200);
    },
    async Fn_CopyDetail(Id) {
      await navigator.clipboard.writeText(Id);
    },
    Fn_ShowImage(image, template_name) {
      if (image.startsWith("data:image")) {
        this.imageShow = image; // ถ้าเป็น base64 ที่ถูกต้องแล้ว
      } else {
        this.imageShow = `data:image/jpeg;base64,${image}`;
      }
      this.TemplateName = template_name;
      this.dialog = true;
    },
    Fn_ShowDetail(detail, name){
      this.ShowDetail = detail;
      this.ShowName = name;
      this.dialogDetail = true;
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    fn_checkActionType(service, item) {
      if (service === "Edit") {
        // store item and go edit page
        this.$store.dispatch("SET_UPDATE_BOT", item);
        this.$router.push("/template-bot-update");
      }
    },
    async Fn_GetAllTemplate() {
      this.isLoading = true;
      var biz_id = this.$cookies.get("BusinessId");
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        Authorization: "Bearer " + auth,
        "Access-Control-Allow-Origin": "*",
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/Template/${biz_id}`,
          {
            headers,
          }
        )
        .then((response) => {
          this.ItemTemplate = response.data.Message;
          this.ItemTemplate = this.ItemTemplate.map((item, index) => {
            const newItem = {};
            for (const key in item) {
              newItem[key] = item[key] === "" ? "" : item[key];
            }
            newItem.no = index + 1;
            return newItem;
          });
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
